export default __webpack_public_path__ + "static/media/IMG_9972.24076ad0.jpg";